import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentVerificationPopup from "./PaymentVerificationPopup";
import { printDebugLog } from "../../Utils/utils";
import { ProductContext } from "../../Contexts/ProductContext";


const PaymentPage = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const { checkPaymentStatus, placeOrderProcess } = useContext(ProductContext);

    const [pgVerifyOpen, setPgVerifyOpen] = useState(false);
    const [pgWaitTime, setPgWaitTime] = useState(20);
    const [pgMsg, setPgMsg] = useState("");
    const [pgSessionKey, setPgSessionKey] = useState("");

    const [billNo, setBillNo] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const q = params.get("data");
        const res = params.get("res");
        const waitTimeStr = localStorage.getItem('waitTimeStr')
        const mBillNo = localStorage.getItem('pay-bill');

        printDebugLog("q value:", q);
        printDebugLog("res value:", res);
        printDebugLog("waitTimeStr value:", waitTimeStr);
        printDebugLog("mBillNo value:", mBillNo);
        if (q) {
            params.delete("data");

            navigate(
                {
                    pathname: location.pathname,
                    search: params.toString() ? `?${params.toString()}` : "",
                },
                { replace: true }
            );
            setPgSessionKey(q);
            setPgVerifyOpen(true);
            setPgWaitTime(waitTimeStr ? parseInt(waitTimeStr) : 13);
            setBillNo(mBillNo);
        } else {
            printDebugLog("No 'data' query parameter found in the URL");
        }
    }, [location, navigate]);

    return (
        <div style={{
            minHeight: "100vh",
            background: "#99bfa4",
            position: "relative",
            overflow: "hidden"
        }}>
            <PaymentVerificationPopup
                isOpen={pgVerifyOpen}
                initialSeconds={pgWaitTime}
                pgMessage={pgMsg}
                onAutoAction={() => {
                    checkPaymentStatus(pgSessionKey, (msg) => {
                        setPgMsg(msg);
                    });
                    console.log("onAutoAction called");
                }}
                onButtonPressed={() => {
                    setPgVerifyOpen(false);
                    setPgMsg("");
                    placeOrderProcess({
                        mBillNo: billNo, mOrderId: "", paymentId: "", paymentSignature: "", navigate: () => {
                            navigate("/userDetails");
                        }
                    });
                }}
            />
        </div>
    );
};

export default PaymentPage;